import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from './api';
import type { AddChildResponse, Child, ParentProfile, UserMode } from '../types/api';
import { CURRENT_CONSENT_VERSION } from '../types/api';

export function useParentProfile() {
  return useQuery({
    queryKey: ['parent', 'profile'],
    queryFn: () => apiFetch<ParentProfile>('/parents/me'),
  });
}

export function useChildren() {
  return useQuery({
    queryKey: ['parent', 'children'],
    queryFn: () =>
      apiFetch<{ children: Child[] }>('/parents/me/children').then((r) => r.children),
  });
}

export function useRegisterParent() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: {
      display_name: string;
      consent_account: boolean;
      consent_ai: boolean;
      consent_curriculum: boolean;
    }) =>
      apiFetch<{ parent_id: string; display_name: string }>('/parents', {
        method: 'POST',
        body: JSON.stringify({ ...body, consent_version: CURRENT_CONSENT_VERSION }),
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['parent'] }),
  });
}

export function useAddChild() {
  const qc = useQueryClient();
  return useMutation({
    mutationFn: (body: {
      display_name: string;
      mode: UserMode;
      school_year: string;
      date_of_birth?: string;
      country: string;
      education_authority?: string;
    }) =>
      apiFetch<AddChildResponse>('/parents/me/children', {
        method: 'POST',
        body: JSON.stringify(body),
      }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['parent', 'children'] }),
  });
}
